export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/eiMst3ZSZXf8uQjpJ1QNLD/IMG_2556.jpg',
    alt: 'Sample page 2.10 Applied Electrical Examples: Ohm’s law, power and energy calculations with series and parallel examples',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xifforRCjYkAzBnHSA6YBL/IMG_2557.jpg',
    alt: 'Sample page 3.2 Irradiance vs. Irradiation with a pyranometer and worked example',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eqZvxCSAAYHi245KTsgSks/IMG_2558.jpg',
    alt: 'Sample page 5.1 From Cells to Modules to Arrays explaining cell, module, string and array',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kHx3GS9hynkSziPiBvwxZN/IMG_2559.jpg',
    alt: 'Sample page 5.3 Module Efficiency with formula and a 20% efficiency example',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gABbuBZkMddNy7AV8wr36r/IMG_2560.jpg',
    alt: 'Sample page 6.1 A Complete PV System from panels and DC wiring to inverter, AC distribution, loads and grid',
  },
];
